import { BackdropProps } from './backdrop-props';
import styled from 'styled-components';

export const Backdrop = styled.div<BackdropProps>`
  background: rgba(0, 0, 0, 0.6);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 2000;
`;
